var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseRoundMark = function SvgCloseRoundMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30.269
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.486 1.455)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 316",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(-.486 -.455)",
    fill: "#102b3f"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(8.513 19.545)",
    fill: "#e8f5f5",
    fontSize: 21,
    fontFamily: "Muli-Bold, Muli",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3251",
    d: "M-.331 14.548v14.266l10.989-4.181Z",
    fill: "#102b3f"
  }))));
};

export default SvgCloseRoundMark;